import React from "react";
import "../../../styles/website/course.css";

const ViewCourse = ({ course, onClose }) => {
  if (!course) return null;

  // Helper function to safely display languages
  const displayLanguages = (languages) => {
    if (!languages) return "NA";
    if (Array.isArray(languages)) return languages.join(", ");
    return languages;
  };

  // Helper function to format time
  const formatTime = (time) => {
    if (!time) return "NA";
    return time;
  };

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <div
        className="modal-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ fontSize: "26px", color: "#333" }}>Course Details</h2>
        <button onClick={onClose} className="close-button">
          X
        </button>
      </div>
      <br />
      <div className="modal-body view-course-details">
        <div className="course-details-content">
          <div className="course-header">
            <h2>{course.title}</h2>
            <span className={`status-badge ${course.status}`}>
              {course.status}
            </span>
          </div>

          <div className="course-info-grid">
            <div className="info-item">
              <label>Category</label>
              <span>{course.category_name || "NA"}</span>
            </div>
            <div className="info-item">
              <label>Duration</label>
              <span>{course.duration || "NA"} days</span>
            </div>
            <div className="info-item">
              <label>Number of People</label>
              <span>{course.accompany_people || "NA"}</span>
            </div>
            <div className="info-item">
              <label>Batch Type</label>
              <span>{course.batch_type || "NA"}</span>
            </div>
            <div className="info-item">
              <label>Languages</label>
              <span>{displayLanguages(course.languages)}</span>
            </div>
            <div className="info-item">
              <label>Price</label>
              <span>₹{course.price || "NA"}</span>
            </div>
            <div className="info-item">
              <label>Age Requirement</label>
              <span>{course.age || "NA"}</span>
            </div>
            <div className="info-item">
              <label>Eligibility</label>
              <span>{course.eligibility || "NA"}</span>
            </div>
          </div>

          <div className="course-schedule">
            <h3>Schedule</h3>
            <div className="schedule-grid">
              <div className="schedule-item">
                <h4>Weekday Schedule</h4>
                <p>Start Time: {formatTime(course.weekday_start_time)}</p>
                <p>End Time: {formatTime(course.weekday_end_time)}</p>
              </div>
              <div className="schedule-item">
                <h4>Weekend Schedule</h4>
                <p>Start Time: {formatTime(course.weekend_start_time)}</p>
                <p>End Time: {formatTime(course.weekend_end_time)}</p>
              </div>
            </div>
          </div>

          <div className="course-description">
            <h3>About Course</h3>
            <p>{course.about_course || "No description available"}</p>
          </div>

          {course.course_content && course.course_content.length > 0 && (
            <div className="course-content">
              <h3>Course Content</h3>
              {course.course_content.map((section, index) => (
                <div key={index} className="content-section">
                  <h4>{section.content_title || "Untitled Section"}</h4>
                  {section.sub_content && section.sub_content.length > 0 && (
                    <ul>
                      {section.sub_content.map((topic, topicIndex) => (
                        <li key={topicIndex}>{topic || "Untitled Topic"}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}

          <div
            className="course-images"
            style={{ display: "flex", gap: "20px" }}
          >
            {course.thumbnail && (
              <div className="image-container">
                <h3>Thumbnail</h3>
                <img
                  src={course.thumbnail}
                  alt="Course Thumbnail"
                  style={{
                    width: "200px",
                    height: "200px",
                  }}
                />
              </div>
            )}
            {course.banner && (
              <div className="image-container">
                <h3>Banner</h3>
                <img
                  src={course.banner}
                  alt="Course Banner"
                  style={{
                    width: "200px",
                    height: "200px",
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCourse;
